import Home from "../Layouts/Home";
import About from "../Layouts/About";
import Rooms from "../Layouts/Rooms";
import Contact from "../Layouts/Contact";
import Room from "../Components/Room";
import Service from "../Components/Service";
import Blog from "../Layouts/Blog";
import Post from "../Components/Post";
import Faq from "../Layouts/Faq";
import Gallery from "../Layouts/Gallery";
import Restaurant from "../Layouts/Restaurant";

const routes = [
    {
        name: 'home',
        path: '/',
        label: 'Home',
        layout: Home,
        meta : {
            title: 'Welcome to The West Heaven Hotel - Book Now!',
            description: 'The West Heaven Hotel it\'s un best quality-price report. Located in Bonapriso the most quiet neighbourhood of the Douala. Book Now.',
            image: '/img/home.jpg'
        }
    },
    {
        name: 'about',
        path: '/about',
        label: 'About',
        layout: About,
        meta : {
            title: 'Why to choose the West Heaven Hotel - the best?',
            description: 'The Hotel you need, The West Heaven Hotel provide you beautiful and comfortable for you holidays, trips and meeting. Trust us.  ',
            image: '/img/about.jpg'
        }
    },
    {
        name: 'rooms',
        path: '/rooms',
        label: 'Rooms',
        layout: Rooms,
        meta : {
            title: 'Find the Room you need at the West Heaven Hotel.',
            description: 'At the West Heaven Hotel, we have so many rooms for all the price. Find yours won\'t never be easy like this.',
            image: '/img/rooms.jpg'
        }
    },
    {
        name: 'blog',
        path: '/blog',
        label: 'Info News',
        layout: Blog,
        meta : {
            title: 'Info News, Promotion and event at the West Heaven Hotel.',
            description: 'All information about the West Heaven Hotel are here. Covid Info, Events and others promotions and news.',
            image: '/img/rooms.jpg'
        }
    },
    {
        name: 'room',
        path: '/room',
        label: 'Room',
        layout: Room,
        meta : {
            title: 'Room $room-name - West Heaven Hotel.',
            description: '$room-short-description',
            image: '$room-featured-image'
        }
    },
    {
        name: 'post',
        path: '/post',
        label: 'Post',
        layout: Post,
        meta : {
            title: '$post-name - West Heaven Hotel.',
            description: '$post-short-description',
            image: '$post-featured-image'
        }
    },
    {
        name: 'service',
        path: '/service',
        label: 'Service',
        layout: Service,
        meta : {
            title: '$service-name - West Heaven Hotel.',
            description: '$service-short-description',
            image: '$service-featured-image'
        }
    },
    {
        name: 'restaurant',
        path: '/restaurant',
        label: 'Restaurant',
        layout: Restaurant,
        meta : {
            title: 'Restaurant - West Heaven Hotel.',
            description: 'Discover our Restaurant and all your favorites dishes. Salads, Main Courses and Dessert, all you need is near to you!',
            image: '$service-featured-image'
        }
    },
    {
        name: 'contact',
        path: '/contact',
        label: 'Contact',
        layout: Contact,
        meta : {
            title: 'Contact the West Heaven Hotel',
            description: 'We are available 24/7j by Phone call, WhatsApp Message, e-mail and also by chat on our facebook page. Contact Us now!',
            image: '/img/contact.jpg'
        }
    },
    {
        name: 'faq',
        path: '/faq',
        label: 'FAQ',
        layout: Faq
    },
    {
        name: 'gallery',
        path: '/gallery',
        label: 'Gallery',
        layout: Gallery
    },
]

export default  routes;